import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { AnalyticsFormService } from '../../../core/services/analytics-form.service';
import { AuthStoreService } from '../../../shared/services/auth/auth-store.service';
import { VerifyCodeForm } from '../../forms/verify-code.form';
import { verifyCodeErrorMessages } from '../../model/verify-code-error-messages';
import { HandsetService } from '../../../core/services/handset.service';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-verify-email',
  styleUrls: ['./verify-code.component.scss'],
  templateUrl: './verify-code.component.html',
})
export class VerifyCodeComponent implements OnInit {
  @Input() public changePasswordUrl: string;
  @Input() public loginUrl: string;
  @Input() public billtechPayMode: boolean;

  public verifyCodeForm = new VerifyCodeForm();

  public email: string;
  public loading: boolean;
  public errors: string[];
  public errorMessages = verifyCodeErrorMessages;
  public submitted = false;
  public formName = 'verificationCodeForm';

  constructor(
    private authStore: AuthStoreService,
    private route: ActivatedRoute,
    private analyticsFormService: AnalyticsFormService,
    private router: Router,
    public handsetService: HandsetService,
  ) {
  }

  public ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get('email');
    if (this.route.snapshot.queryParamMap.has('code')) {
      this.verifyCodeForm.verificationState.setValue(this.route.snapshot.queryParamMap.get('code'));
      this.verifyCodeForm.verificationState.markAsTouched();
    }
    this.verifyCodeForm.email.setValue(this.email);
  }

  public onCodeVerify(): void {
    if (this.verifyCodeForm.valid) {
      this.loading = true;
      this.authStore
        .verifyCode(this.verifyCodeForm.value)
        .pipe(
          catchError((errors) => {
            this.errors = errors;
            this.verifyCodeForm.verificationState.setErrors({});
            this.analyticsFormService.sendEventForCaughtError('verificationState', this.formName);
            return throwError(() => errors);
          }),
          switchMap(() => this.router.navigate([this.changePasswordUrl, this.verifyCodeForm.verificationState.value], {
            queryParams: {
              email: this.email,
            },
          })),
          finalize(() => (this.loading = false)),
        )
        .subscribe();
    } else {
      this.submitted = true;
      this.analyticsFormService.sendEventForInvalidControls(this.verifyCodeForm.controls, this.formName);
    }
  }

  getQueryParams() {
    return {};
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
